import { useNavigate, useLocation } from "react-router-dom";
import { BarChart3, Link, LogOut } from "lucide-react";

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('nutrinori_token');
    localStorage.removeItem('nutrinori_email');
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: BarChart3, label: 'Dashboard', testId: 'nav-dashboard' },
    { path: '/admin/links', icon: Link, label: 'Liens', testId: 'nav-links' }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F6F1E9' }}>
      {/* Sidebar */}
      <div className="fixed left-0 top-0 h-full w-64 bg-white border-r" style={{ borderColor: 'rgba(61, 107, 74, 0.15)' }}>
        <div className="p-6">
          <h1 className="text-xl font-bold" style={{ color: '#3D6B4A' }} data-testid="admin-sidebar-title">
            NutriNori Admin
          </h1>
        </div>

        <nav className="px-3">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-all duration-150"
                style={{
                  backgroundColor: isActive ? '#E8F0EA' : 'transparent',
                  color: isActive ? '#3D6B4A' : '#6B756D'
                }}
                data-testid={item.testId}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-red-50 transition-colors"
            style={{ color: '#6B756D' }}
            data-testid="logout-button"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Déconnexion</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="ml-64 p-8">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
